import React, { useCallback, useEffect, useMemo, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { viewInvitesList } from "../../Redux/Actions/invitesAction";
import { columnsInvites } from "../../Global Functions/columnsAntd";

const ListInvites = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const { invites } = useSelector((state) => state.invites || {});

  const dispatch = useDispatch();

  const fetchDetails = useCallback(async (page, pageSize) => {
    const invitesData = {
      page,
      limit: pageSize,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(viewInvitesList(invitesData));
    } catch {
      toast.error("Failed to refresh user list");
    }
  }, [dispatch, debouncedSearch, dateRange]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, debouncedSearch, dateRange, fetchDetails]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);


  useEffect(() => {
    if (invites?.total) {
      setPagination((prevData) => ({ ...prevData, total: invites.total }));
    }
  }, [invites]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  const columns = useMemo(() => columnsInvites, []);

  const dataSource = useMemo(
    () => (Array.isArray(invites?.data.data) ? invites.data.data : []),
    [invites]
  );

  return (
    <>
      <TableComponent
        h3heading="Invites List"
        pagination={pagination}
        columns={columns}
        dataSource={dataSource}
        setState={setSearchQuery}
        onChange={handleTableChange}
        onCalendarClick={() => setIsDatePopupVisible(true)}
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListInvites;
